import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import companyData from "../Data/CompanyData";
import categories from "../Data/Categories";
import { Card, CardContent, CardFooter } from "../components/ui/card";
import { Button } from "../components/ui/button";

const LatestTenders = () => {
  const [tenders, setTenders] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/licit/get_latest_tenders`)
      .then((response) => response.json())
      .then((data) => {
        // Filtrar solo licitaciones si es mobile
        if (isMobile) {
          setTenders(data.tenders.slice(0, 2) || []); // Solo una licitación en móvil
        } else {
          setTenders(data.tenders || []);
        }
      })
      .catch((error) => console.error("Error fetching tenders:", error));
  }, [isMobile]);

  // Detectar cambio de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Función para encontrar el icono basado en la categoría
  const getCategoryIcon = (categoryLabel) => {
    // Buscar en companyData.sectores
    const companyCategory = companyData.sectores.find(
      (sector) => sector.label === categoryLabel
    );

    // Buscar en categories, excluyendo "Otro Servicio"
    const generalCategory = categories.find(
      (cat) => cat.label === categoryLabel && cat.label !== "Otro Servicio"
    );

    return companyCategory?.icon || generalCategory?.icon || "❓"; // Fallback si no encuentra
  };

  return (
    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
      <h2 className="text-2xl font-semibold text-foreground sm:text-3xl">
        Últimas Licitaciones Publicadas
      </h2>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {tenders.length > 0 ? (
          tenders.map((tender) => (
            <Card key={tender.id_tender} className="flex flex-col">
              <CardContent className="flex-1 pt-6">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">{getCategoryIcon(tender.categoria)}</span>
                  <h3 className="font-semibold text-foreground">{tender.titulo}</h3>
                </div>
                <div className="mt-4 space-y-2 text-sm">
                  <p className="text-muted-foreground">
                    <strong className="text-foreground">Categoría:</strong> {tender.categoria}
                  </p>
                  <p className="hidden text-muted-foreground sm:block">
                    <strong className="text-foreground">Creador:</strong>{" "}
                    {tender.creador.length > 35
                      ? `${tender.creador.slice(0, 35).trim()}...`
                      : tender.creador}
                  </p>
                  <p className="hidden text-muted-foreground sm:block">
                    <strong className="text-foreground">Fecha máxima para postular:</strong>{" "}
                    {tender.fecha_maxima_postulacion}
                  </p>
                  <p className="text-muted-foreground">
                    <strong className="text-foreground">Descripción:</strong> {tender.descripcion}
                  </p>
                </div>
              </CardContent>
              <CardFooter>
                <Button variant="outline" className="w-full" onClick={() => navigate("/licitaciones/")}>
                  Ver más
                </Button>
              </CardFooter>
            </Card>
          ))
        ) : (
          <p className="text-muted-foreground">No hay licitaciones disponibles en este momento.</p>
        )}
      </div>
    </section>
  );
};

export default LatestTenders;
